var animationEasingCurves;

(function (animationEasingCurves) {
  animationEasingCurves["linear"] = "cubic-bezier(1, 1, 0, 0)";
  animationEasingCurves["easeIn"] = "cubic-bezier(0.5, 0, 1.0, 1.0)";
  animationEasingCurves["easeOut"] = "cubic-bezier(0, 0, 0.5, 1.0)";
  animationEasingCurves["easeBoth"] = "cubic-bezier(0.25, 0.1, 0.25, 1.0)";
})(animationEasingCurves || (animationEasingCurves = {}));

export default animationEasingCurves;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/animation/primitives/easing/index.js
// module id = 311
// module chunks = 12